import React, {useEffect, useState} from 'react';
import { useTranslation, Trans } from 'react-i18next';
import axios from 'axios';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import '../static/css/skiRentalPage.css';

import { ReactComponent as CloseModal } from '../assets/closeMenu.svg';

import LogoImage from '../assets/img/ski-rental-page/oaza-logo-black.png';

const RentalModalWindow = ({title, description, onClose}) => {

  return (
    <div className='container-fluid bg-dark bg-opacity-75 position-fixed top-0 start-0 d-flex justify-content-center align-items-center' style={{height: "100dvh"}}>
        <div className='col-12 col-md-10 col-lg-8 col-xxl-6 bg-color-dark-skin h-75 px-4 pt-5'>
            <div className='col-12 d-flex justify-content-end'><a className='cursor-pointer' onClick={(e) => onClose(false)}><CloseModal /></a></div>
            <h1 className='text-white text-center mb-4'>{title}</h1>
            <p className='text-white text-center'>{description}</p>
        </div>
    </div>
  )
}

const SkiRentalPage = () => {
    gsap.registerPlugin(ScrollTrigger);

    const { t, i18n } = useTranslation();

    const [rentalEquipmentInfo, setRentalEquipmentInfo] = useState([]);
    const [chosenService, setChosenService] = useState(1);
    let [isOpenModal, setIsOpenModal] = useState(false),
        [modalEquipmentTitle, setModalEquipmentTitle] = useState(''),
        [modalEquipmentDescription, setModalEquipmentDescription] = useState('');
    

    useEffect(() => {
        gsap.set('.header', {backgroundColor: "#191A1A"})
        gsap.set('.active', {opacity: 0});
        gsap.to('.active', {opacity: 1, duration: 0.3});

        // if (chosenService == 1) {
        //     gsap.to('.phrase-container', {top: 0, duration: 0.7, ease: "back.inOut(1.7)"});
        // } else if (chosenService == 2) {
        //     gsap.to('.phrase-container', {top: -140, duration: 0.7, ease: "back.inOut(1.7)"});
        // } else {
        //     gsap.to('.phrase-container', {top: -280, duration: 0.7, ease: "back.inOut(1.7)"});
        // }
    }, [chosenService]);

    let changeServiceSlide = async (nextSlideNumber) => {
        gsap.to('.active', {
            opacity: 0,
            duration: 0.3,
            onComplete: () => {
                setChosenService(nextSlideNumber);
            }
        });
    }

  return (
    <div className='bg-color-dark' style={{minHeight: "100vh"}}>
        <section className='container-fluid bg-soft-white d-flex justify-content-center m-0 p-0' style={{minHeight: "100vh"}}>
            <div className='col-12 d-flex flex-column flex-md-row justify-content-end align-items-end header-offset '>
                
                <div className='col-12 col-sm-3 d-flex flex-column justify-content-center align-items-center h-100 rental-logo-container'>
                    <p className='services-page-title'>НАШІ ПОСЛУГИ</p>
                    <img src={LogoImage} alt='Oaza logo' className='col-4 col-sm-8 col-md-9 img-fluid'/>
                </div>

                <div  className='col-12 col-md-9 d-flex flex-column justify-content-start align-items-center' style={{backgroundColor: "#191A1A", minHeight: "80vh"}}>
                    <div className='col-12 my-5 d-flex flex-column flex-sm-row justify-content-center align-items-center column-gap-1 column-gap-md-5 row-gap-3'>
                        <a
                            className={'col-10 col-sm-3 col-xl-2 text-center text-dark-grey-color font-gilroy-regular border border-1 border-color-dark-grey cursor-pointer services-info-button ' + (chosenService == 1 ? 'active-button disabled' : '')}
                            aria-disabled={chosenService == 1}
                            onClick={(e) => { if (chosenService !== 1) changeServiceSlide(1); }}
                        >{i18n.t('services_page_button_1')}</a>
                        <a
                            className={'col-10 col-sm-3 col-xl-2 text-center text-dark-grey-color font-gilroy-regular border border-1 border-color-dark-grey cursor-pointer services-info-button ' + (chosenService == 2 ? 'active-button disabled' : '')}
                            aria-disabled={chosenService == 2}
                            onClick={(e) => { if (chosenService !== 2) changeServiceSlide(2); }}
                        >{i18n.t('services_page_button_2')}</a>
                        <a
                            className={'col-10 col-sm-3 col-xl-2 text-center text-dark-grey-color font-gilroy-regular border border-1 border-color-dark-grey cursor-pointer services-info-button ' + (chosenService == 3 ? 'active-button disabled' : '')}
                            aria-disabled={chosenService == 3}
                            onClick={(e) => { if (chosenService !== 3) changeServiceSlide(3); }}
                        >{i18n.t('services_page_button_3')}</a>
                    </div>

                    <div className='col-11 bg-white mb-4' style={{height: "1px"}}></div>

                    {chosenService === 1 ?
                    <div className='col-12 d-flex flex-column align-items-center active mb-5 mb-sm-0' style={{minHeight: "30vh"}}>
                        <div className='col-11 d-flex flex-column justify-content-start'>
                            <p className='text-white text-center font-montserrat-light lifts-title mb-5 mt-1'>{i18n.t('services_page_card_1_title')}</p>

                            <div className='d-flex flex-column flex-xl-row justify-content-between'>
                                <div className='col-12 col-xl-5 col-xxl-4 d-flex flex-column'>
                                    <p className='text-white font-montserrat-regular lifts-desctiption-text'><Trans i18nKey="services_page_card_1_description" components={{ br: <br /> }} /></p>

                                    <p className='text-white font-montserrat-regular mt-3 lifts-desctiption-text'>{<Trans i18nKey='services_page_card_1_hours' components={{ bold: <span className='fw-bold'/> }}/>}</p>
                                </div>

                                <div className='col-12 col-xl-7 col-xxl-8 d-flex flex-column justify-content-between align-items-end'>
                                    <div className='col-12 col-lg-11 d-flex flex-wrap mobile-my-3'>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-dark-grey-color font-montserrat-light text-center'>{i18n.t('services_page_card_1_table_cable_length')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>360 м.</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>840 м.</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>1000 м.</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-dark-grey-color font-montserrat-light'>{i18n.t('services_page_price_text')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>70 {i18n.t('currency')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>100 {i18n.t('currency')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>130 {i18n.t('currency')}</p></div>
                                    </div>

                                    <div>
                                        <p className='text-white text-end my-1 font-montserrat-regular fst-italic'>{i18n.t('services_page_card_1_discount_1')}</p>
                                        <p className='text-white text-end my-1 font-montserrat-regular fst-italic'>{i18n.t('services_page_card_1_discount_2')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : <p className='p-0 m-0'></p>}

                    {chosenService === 2 ?
                    <div className='col-12 d-flex flex-column align-items-center active mb-5 mb-sm-0' style={{minHeight: "30vh"}}>
                        <div className='col-11 d-flex flex-column justify-content-start'>
                            <p className='text-white text-center font-montserrat-light lifts-title mb-5 mt-1'>{i18n.t('services_page_card_2_title')}</p>

                            <div className='d-flex flex-column flex-sm-row justify-content-between row-gap-3 row-gap-sm-0'>
                                <div className='col-11 col-sm-5 pe-3'>
                                    <p className='text-white font-montserrat-regular lifts-desctiption-text'><Trans i18nKey="services_page_card_2_description" components={{ br: <br /> }} /></p>
                                </div>

                                <div className='col-11 col-sm-5'>
                                    <p className='font-montserrat-light rental-price-title mt-0'>{i18n.t('services_page_price_text')}</p>
                                    <p className='text-white font-montserrat-regular mb-2'>{i18n.t('services_page_card_2_equipment_prices')}</p>
                                    <p className='text-white font-montserrat-regular rental-kids-price-text'>{i18n.t('services_page_card_2_kids_equipment_prices')}</p>
                                </div>
                            </div>
                        </div>
                    </div> : <p className='p-0 m-0'></p>}

                    {chosenService === 3 ?
                    <div className='col-12 d-flex flex-column align-items-center active mb-5 mb-sm-3' style={{minHeight: "30vh"}}>
                        <div className='col-11 d-flex flex-column justify-content-start'>
                            <p className='text-white text-center font-montserrat-light lifts-title mb-5'>{i18n.t('services_page_card_3_title')}</p>

                            <div className='d-flex flex-column flex-xl-row justify-content-between mt-4'>
                                <div className='col-11 col-xl-5 col-xxl-4 d-flex flex-column'>
                                    <p className='text-white font-montserrat-regular lifts-desctiption-text'><Trans i18nKey="services_page_card_3_description" components={{ br: <br /> }} /></p>
                                </div>

                                <div className='col-12 col-xl-7 col-xxl-8 d-flex flex-column justify-content-between align-items-start align-items-xl-end'>
                                    <p className='text-white align-self-start offset-xl-1 mt-0'>{i18n.t('services_page_card_3_teacher')}</p>
                                    <div className='col-12 col-sm-11 d-flex flex-wrap'>
                                        <div className='col-3 col-sm-2 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-dark-grey-color font-montserrat-light'>{i18n.t('services_page_card_3_table_people_amount')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>1 {i18n.t('services_page_card_3_table_1_person')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>2 {i18n.t('services_page_card_3_table_2_more_people')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>3 {i18n.t('services_page_card_3_table_2_more_people')}</p></div>
                                        <div className='col-3 col-sm-2 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-dark-grey-color font-montserrat-light'>{i18n.t('services_page_card_3_table_price_per_hour')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>1500 {i18n.t('currency')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>2200 {i18n.t('currency')}</p></div>
                                        <div className='col-3 lifts-prices-table-item d-flex align-items-center justify-content-center'><p className='text-white fs-5 font-montserrat-light rental-lifts-price'>2700 {i18n.t('currency')}</p></div>
                                    </div>

                                    <p className='text-white align-self-start offset-xl-1 my-1 mt-5 font-montserrat-regular'>{i18n.t('services_page_card_3_teacher_guide')}</p>
                                </div>
                            </div>
                        </div>
                    </div> : <p></p>}

                </div>
            </div>
        </section>
    </div>
  )
}

export default SkiRentalPage